import { HeaderQuestion as HeaderQuestionType } from "./questionTypes";
import { Button } from "@/components/ui/button";
interface HeaderQuestionProps {
  question: HeaderQuestionType;
  onNext: () => void;
}
export function HeaderQuestion({
  question,
  onNext
}: HeaderQuestionProps) {
  return <div className="space-y-6 text-center max-w-2xl mx-auto">
      <div className="space-y-4">
        
        {question.description && <p className="font-semibold text-primary">
            {question.description}
          </p>}
      </div>
    </div>;
}